import { FileExportFormat } from '@epicuro-next/ataraxia/models';
import { createAction, props } from '@ngrx/store';
import { BasketAccountAddress } from 'graphql-api/baskets-api-interfaces';

/**
 * A generic basket action triggered using the actions dropdown in cbasket
 */
export const clearBasket = createAction('[Basket Actions] Clear Basket');

export const clearBasketSuccess = createAction(
  '[Basket Actions] Clear Basket Success',
);

export const clearBasketFailure = createAction(
  '[Basket Actions] Clear Basket Fail',
  props<{ error: string }>(),
);

export const copyBasket = createAction('[Basket] Copy Basket');

export const reuseBasket = createAction(
  '[Basket] Reuse Basket',
  props<{ basketId: string }>(),
);

export const reuseBasketSuccess = createAction(
  '[Basket] Reuse Basket Success',
  props<{ basketId: string }>(),
);

export const reuseBasketFailure = createAction(
  '[Basket] Reuse Basket Failure',
  props<{ error: string }>(),
);

export const moveBasketSuccess = createAction(
  '[Basket] Move Basket Success',
  props<{ basketId: string }>(),
);

export const downloadBasket = createAction(
  '[Basket Actions] Download basket',
  props<{ format: FileExportFormat }>(),
);

export const downloadBasketH2 = createAction(
  '[Basket Actions] Download H2 basket',
);

export const downloadBasketSuccess = createAction(
  '[Basket Actions] Download basket Success',
);

export const downloadBasketFailure = createAction(
  '[Basket Actions] Download basket Failure',
  props<{ error: string }>(),
);

export const downloadBasketPdfAsync = createAction(
  '[Basket Actions] Download basket pdf async',
);

export const copyProductsToShops = createAction(
  '[Basket] Copy products to shops',
  props<{ fromShop: BasketAccountAddress; toShops: BasketAccountAddress[] }>(),
);

export const sendPdfConfirmation = createAction(
  '[Basket] Send PDF Confirmation',
);

export const sendPdfConfirmationSuccess = createAction(
  '[Basket] Send PDF Confirmation Success',
);

export const sendPdfConfirmationFailed = createAction(
  '[Basket] Send PDF Confirmation Failed',
  props<{ message: string }>(),
);
